var _path, _rect, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 53,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.797 7.322h-9.191a7 7 0 0 0-6.82 5.426L5.317 40.772c-.955 4.14 1.969 8.17 6.202 8.547l29.837 2.65a7 7 0 0 0 7.233-4.681l8.029-23.17c1.575-4.548-1.802-9.292-6.614-9.292h-9.056a7 7 0 0 1-5.065-2.168L32.863 9.49a7 7 0 0 0-5.066-2.169Z",
    fill: "#C7C5CB"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.531,
    width: 37.16,
    height: 42.113,
    rx: 2,
    transform: "rotate(11.161 18.531 0)",
    fill: "#DFDEE3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.76 8.826H7a7 7 0 0 0-7 7v29.291a7 7 0 0 0 7 7h34.138a7 7 0 0 0 7-7V23.33a7 7 0 0 0-7-7H27.911a7 7 0 0 1-5.065-2.168l-3.02-3.167a7 7 0 0 0-5.066-2.169Z",
    fill: "#9B9BA5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4 25.597c.647 0 1.17.524 1.17 1.17v6.63h6.63a1.17 1.17 0 1 1 0 2.34h-6.63v6.63a1.17 1.17 0 1 1-2.34 0v-6.63H15.6a1.17 1.17 0 1 1 0-2.34h6.63v-6.63c0-.646.524-1.17 1.17-1.17Z",
    fill: "#DFDEE3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(14.04 25.207)",
    d: "M0 0h18.72v18.72H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.53476f86.svg";
export { ForwardRef as ReactComponent };